import { useState } from "react";
import React from 'react';
import {
    MDBCard,
    MDBCardImage,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBListGroup,
    MDBListGroupItem,
} from 'mdb-react-ui-kit';



const TestAnalysisCard = ({ index, Question, QuestionImg = "", QuestionType, YourAns, CorrectAns, status }) => {
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    return (
        <MDBCard className='w-full max-w-[20rem] m-3 p-3'>
            <MDBCardTitle>Question {index + 1}</MDBCardTitle>
            {QuestionImg && <MDBCardImage position='top' alt='...' src={QuestionImg} />}
            <MDBCardBody>
                <MDBCardText >
                    {Question.length > 150 ?
                        (
                            <div>
                                {isReadMore ? Question.slice(0, 150) : Question}
                                <span onClick={toggleReadMore} className="read-or-hide underline p-1 text-indigo-500 cursor-pointer">
                                    {isReadMore ? "... Read More" : " show less"}
                                </span>
                            </div>
                        )
                        :
                        (
                            Question
                        )
                    }
                </MDBCardText>
                <div className="border-2 border-blue-600 rounded-lg text-center py-2 text-blue-400">{QuestionType}</div>
            </MDBCardBody>
            <MDBListGroup flush className="gap-3">
                <MDBListGroupItem >
                    <span className="font-extrabold">Your Answer : </span>
                    {YourAns.length > 150 ?
                        (
                            <div>
                                {isReadMore ? YourAns.slice(0, 150) : YourAns}
                                <span onClick={toggleReadMore} className="read-or-hide underline p-1 text-indigo-500 cursor-pointer">
                                    {isReadMore ? "... Read More" : " show less"}
                                </span>
                            </div>
                        )
                        :
                        (
                            YourAns
                        )
                    }
                </MDBListGroupItem>
                <MDBListGroupItem >
                    <span className="font-extrabold">Correct Answer : </span>
                    {CorrectAns.length > 150 ?
                        (
                            <div>
                                {isReadMore ? CorrectAns.slice(0, 150) : CorrectAns}
                                <span onClick={toggleReadMore} className="read-or-hide underline p-1 text-indigo-500 cursor-pointer">
                                    {isReadMore ? "... Read More" : " show less"}
                                </span>
                            </div>
                        )
                        :
                        (
                            CorrectAns
                        )
                    }
                </MDBListGroupItem>
            </MDBListGroup>
            <MDBCardBody>
                {status === 0 ?
                    (
                        <MDBListGroupItem className="text-xl">Unattempted , 0</MDBListGroupItem>

                    ) :
                    (status === 4) ? (
                        <MDBListGroupItem className="text-xl">Correct , +4</MDBListGroupItem>
                    ) : (status === -1) ? (
                        <MDBListGroupItem className="text-xl">Incorrect , -1</MDBListGroupItem>
                    )
                        : (
                            <MDBListGroupItem className="text-xl">Incorrect , 0</MDBListGroupItem>
                        )
                }
            </MDBCardBody>
        </MDBCard>
    );
}

export default TestAnalysisCard;